<template>
  <div class="new-search">
    <h1>Real-Time KSL Monitoring</h1>
    <p>Get email alerts the moment an item you're looking for is posted on KSL</p>
    <h2>Get started for <strong>FREE</strong> by choosing a category and subcategory</h2>
    <SearchBox />
  </div>
</template>

<script>
import SearchBox from '@/components/SearchBox.vue'

export default {
  name: 'NewSearch',
  components: {
    SearchBox
  }
}
</script>
